import { Typography } from "@mui/material";
import { Flex } from "Components/_Shared/Core/Flex";
import { useEffect, useRef } from "react";
import { useFormContext, useWatch } from "react-hook-form";

type Props = {
  characterLimit: number;
  characterMinLength?: number;
  name: string;
};

const THRESHOLD = 0.8;

export const FormCharacterCounter = ({ characterLimit, characterMinLength, name }: Props) => {
  const { control, getValues, trigger } = useFormContext();

  const inputValue = useWatch({
    control,
    name,
    defaultValue: getValues(name),
  });

  const textLength = inputValue?.length || 0;
  const hasMaxLength = textLength > characterLimit;
  const hasMinLength = characterMinLength != null && textLength > 0 && textLength < characterMinLength;
  const shouldShow = textLength > characterLimit * THRESHOLD || hasMinLength;

  const previousHasMaxLength = useRef(hasMaxLength);

  useEffect(() => {
    if (previousHasMaxLength.current !== hasMaxLength) {
      previousHasMaxLength.current = hasMaxLength;
      trigger(name);
    }
  }, [hasMaxLength, trigger, name]);

  return (
    <Flex justifyContent="flex-end" minWidth="50px" flexGrow={1} alignItems={"flex-end"}>
      {shouldShow && (
        <Typography fontSize={"small"} color={hasMaxLength || hasMinLength ? "error.main" : "gray.600"}>
          {`${inputValue ? textLength : "0"}/${characterLimit}`}
        </Typography>
      )}
    </Flex>
  );
};
